import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingPages } from '../../../../common/src/pages.ts';
import { LocalStorageKey } from '../../data/client_local_storage.ts';
import { useLocalStorage } from '../../data/use_local_storage.tsx';
import { Button } from './button.tsx';
import {
  BoldMessage,
  getRedeemablePromoCampaignSlug,
  goToNextOnboardingStep,
  isAdminInvite,
  Message,
} from './common.tsx';
import { Frame } from './frame.tsx';

export const HouseholdNotFound = () => {
  const [householdEmail] = useLocalStorage(LocalStorageKey.OnboardingHouseholdEmail);
  const navigate = useNavigate();

  const onChangeEmail = useCallback(async () => {
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.HouseholdNotFound, action: 'tryAgain' });
  }, [navigate]);

  const onNewHousehold = useCallback(async () => {
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.HouseholdNotFound, action: 'newHousehold' });
  }, [navigate]);

  // A promotional campaign's visitor is usually new, so an unknown email most likely means a household
  // to create: confirm it rather than suggest a retry. The household is then created with this email
  // without asking for it again (GitHub issue #3551).
  if (getRedeemablePromoCampaignSlug()) {
    return (
      <Frame
        onboardingPage={OnboardingPages.HouseholdNotFound}
        mainContent={
          <Message $widthInChars={26}>
            Please confirm you'd like to create a household with <BoldMessage>{householdEmail}</BoldMessage>.
          </Message>
        }
        footerContent={
          <>
            <Button onClick={onNewHousehold}>CREATE HOUSEHOLD</Button>
            <Button onClick={onChangeEmail}>RETYPE EMAIL</Button>
          </>
        }
        onEnterKeypress={onNewHousehold}
      />
    );
  }

  const content = isAdminInvite() ? (
    <Message $widthInChars={26}>
      This will create a new household with email <BoldMessage>{householdEmail}</BoldMessage>.
    </Message>
  ) : (
    <Message $widthInChars={26}>
      We could not find a household with email <BoldMessage>{householdEmail}</BoldMessage>.<br />
      <br />
      Would you like try another email?
    </Message>
  );

  const footerContent = isAdminInvite() ? (
    <>
      <Button onClick={onNewHousehold}>SOUNDS GREAT</Button>
      <Button onClick={onChangeEmail}>I ALREADY HAVE A HOUSEHOLD</Button>
    </>
  ) : (
    <>
      <Button onClick={onChangeEmail}>TRY AGAIN</Button>
      <Button onClick={onNewHousehold}>NEW HOUSEHOLD</Button>
    </>
  );

  return (
    <Frame
      onboardingPage={OnboardingPages.HouseholdNotFound}
      mainContent={content}
      footerContent={footerContent}
      onEnterKeypress={isAdminInvite() ? onNewHousehold : onChangeEmail}
    />
  );
};
